import React, { CSSProperties } from 'react';
import { Container } from '@/components';
import ProductPlaceholder from '../Product/ProductPlaceholder';
import { GetStoreMetadata } from '@/data';
import { SPACING_VALUES } from '@/utils';
import styles from './products.module.scss';

const ProductsSkeleton = async () => {
  const data = await GetStoreMetadata();
  const productCard = data?.productCard;
  const { isLargeCard, spacingBetweenCard } = productCard.displayProps;

  const selectedSpacing =
    SPACING_VALUES[spacingBetweenCard] || SPACING_VALUES.small;

  return (
    <Container
      className={styles.products__carousel_placeholder}
      style={
        {
          '--gap-default': `${selectedSpacing.default}px`,
          '--gap-sm': `${selectedSpacing.sm}px`,
          '--gap-md': `${selectedSpacing.md}px`,
          '--gap-xl': `${selectedSpacing.xl}px`,
          '--gap-xxl': `${selectedSpacing.xxl}px`,
        } as CSSProperties
      }
    >
      {Array.from({ length: 20 }).map((_, index) => (
        <ProductPlaceholder key={index} largeCard={isLargeCard} />
      ))}
    </Container>
  );
};

export { ProductsSkeleton };
